import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderStatusService } from '../services/loader-status.service';

const API_REQUEST_EXCEPTIONS = [
  'maps-api',
  'PowerBiDashboard', 'noodoe', 'Ocra', 'LivePreview',
  'RevenueControl/Devices', 'RevenueControl/Rates'
];

const API_BODY_EXCEPTIONS = [
  'IncludeRegisteredDevices'
];

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  private activeRequestsCount = 0;

  constructor(
    private loaderStatusService: LoaderStatusService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isTrackedRequest = request.url.includes('/api/')
      && request.method !== 'OPTIONS'
      && !this.requestExistException(request.url)
      && !this.requestBodyExistException(request.body);

    if (isTrackedRequest) {
      this.activeRequestsCount++;
      this.loaderStatusService.setLoadingStatus(true);
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (isTrackedRequest) {
          this.activeRequestsCount--;

          if (this.activeRequestsCount === 0) {
            this.loaderStatusService.setLoadingStatus(false);
          }
        }
      })
    );
  }

  private requestExistException(url: string): boolean {
    return API_REQUEST_EXCEPTIONS.some(exception => url.includes(exception));
  }

  private requestBodyExistException(body: any): boolean {
    if (!body || typeof body !== 'object' || body.toString() === '[object FormData]') {
      return false;
    }

    return API_BODY_EXCEPTIONS.some(exceptionKey => {
      return body[exceptionKey] === true;
    });
  }
}
